import React, { useCallback } from 'react';
import { clsx } from '@core/js/utils/classNames.util';
import { compose, omit } from 'ramda';
import { defaultProps, mapProps } from 'recompose';
import { withTranslations } from '@core/js/components/hocs/withTranslations';
import { Button } from '@theme/js/components/common/Button';
import withGameLaunch from '@core/js/components/common/Game/withGameLaunch';

import style from './index.scss';

export const tKeyPrefix = 'playtech.mobile.system.button';

export const PlayButton = compose(
    defaultProps({
        mode: 1,
        className: '',
        tKey: `${tKeyPrefix}.realPlay`
    }),
    withTranslations,
    withGameLaunch,
    mapProps(omit(['code']))
)(({
    launchGame,
    gameLaunchType,
    name: gameName,
    mode,
    tKey,
    t,
    className = '',
    isHoverBtn,
    container,
    gameFeed,
    queryString,
    onGameLaunched,
    categoryName, /* TotalCasino changes */
    randomGame = false, /* TotalCasino changes */
    ...others
}) => {
    const onClick = useCallback(() => {
        /* TotalCasino changes - Game portlet categoryName support */
        launchGame({
            container,
            gameFeed,
            gameName,
            queryString,
            categoryName,
            onGameLaunched,
            gameLaunchType,
            randomGame,
            launchType: mode ? 'Real' : 'Demo'
        });
    }, [launchGame, container, gameFeed, gameName, queryString, onGameLaunched, gameLaunchType, mode, categoryName, randomGame]);

    return (
        <Button
            onClick={onClick}
            className={clsx([
                className,
                style.button,
                isHoverBtn && style[mode ? 'play' : 'demo']
            ])}
            {...others}>
            {t(tKey)}
        </Button>
    );
});

export const DemoButton = props =>
    <PlayButton
        mode={0}
        tKey={`${tKeyPrefix}.demoPlay`}
        view="secondary"
        color="info"
        {...props}
    />;
